import React, { useEffect } from 'react'
import LayoutActions from '../redux/actions/LayoutActions'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import UserRoute from '../routers/UserRoute'
import { connect } from 'react-redux'
import { Box } from '@mui/system'
import { layoutPageComponents as components } from './components/layoutPageComponents'
import { subscribeToRouteSync } from '../utils/routeSyncBridge'

const stripBase = (path) => {
    const base = window.__ADMIN_STOCK_BASENAME__ || '';
    if (!base) return path;
    if (path === base || path === `${base}/`) return '/';
    if (path.startsWith(`${base}/`)) return path.slice(base.length) || '/';
    return path;
};

/**
 * Nested layout for the Suppliers group inside Setup (`suppliersLayout`), holding the
 * Suppliers list (`stockSuppliers`) and Suppliers Payment (`suppliersPayment`) tabs.
 *
 * It owns `pathCheck` while any of its routes is active, which is what makes StockLayout render
 * the two-level tab bar (Setup tabs + this group's tabs) — see `getHeader` there.
 */
function SuppliersLayout({
    setPathCheck,
    permission,
    reformat
}) {
    const access = reformat(permission.subPage)
        .sort((a, b) => {
            // Check if either 'order' is null
            if (a.order === null && b.order === null) {
                return 0; // Keep the order unchanged if both are null
            } else if (a.order === null) {
                return 1; // Place 'a' (null) after 'b' (non-null)
            } else if (b.order === null) {
                return -1; // Place 'b' (null) after 'a' (non-null)
            }
            // Sort non-null 'order' values normally
            return a.order - b.order;
        });

    useEffect(() => {
        // For microfrontend, sync with parent route changes via window.location.pathname
        const checkPathname = () => {
            const strippedPathname = stripBase(window.location.pathname);

            if (strippedPathname === permission.route || strippedPathname.startsWith(permission.route + '/')) {
                setPathCheck(permission.route);
            }
        };

        return subscribeToRouteSync(checkPathname);
    }, [permission.route, setPathCheck])
console.log(access)
    return (
        <div style={{ height: '100%' }}>
            <Box sx={{ height: '100%' }}>
                <Switch>
                    <Route
                        exact
                        path={permission.route}
                        render={({ location }) => {
                            // This MFE's router and the browser URL are synced by StockLayout's
                            // poll, so on a hard refresh of a child route the router can sit on
                            // this group's base route for a tick. Redirecting to the first tab
                            // then would silently eat the deep link (and stick, because the
                            // redirect rewrites the browser URL too) — so restore the URL the
                            // browser is actually on and only fall back to the first tab when
                            // the base route is genuinely where we are.
                            const browserPath = stripBase(window.location.pathname);
                            if (
                                browserPath !== location.pathname &&
                                browserPath.startsWith(permission.route + '/')
                            ) {
                                return <Redirect to={browserPath} />;
                            }
                            return <Redirect to={access[0]?.route} />;
                        }}
                    />
                    {access.map((permission2, i) =>
                        <UserRoute key={i} exact path={permission2.route} component={components[permission2.key]} permission={permission2} />
                    )}
                    <Redirect from="*" to="/not-found" />
                </Switch>
            </Box>
        </div>
    )
}
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
    setPathCheck: (data) => dispatch(LayoutActions.setPathCheck(data)),
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SuppliersLayout))
